import React, { Fragment, useState } from 'react';
import { Card, Row, Col, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { P, H5 } from '../../../../AbstractElements';

const Tabset = ({ event }) => {
  const [activeTab, setActiveTab] = useState('1');

  if (!event) {
    return (
      <Fragment>
        <Card>
          <div className="text-center py-4">
            <p>Không có thông tin sự kiện</p>
          </div>
        </Card>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Card>
        <div className='product-page-main'>
          <Row className='m-0'>
            <Col sm='12'>
              <Nav tabs className='border-tab nav-primary mb-0 '>
                <NavItem id='myTab' role='tablist'>
                  <NavLink href='#' className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>
                    Mô tả
                  </NavLink>
                  <div className='material-border'></div>
                </NavItem>
                <NavItem id='myTab' role='tablist'>
                  <NavLink href='#' className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>
                    Video
                  </NavLink>
                  <div className='material-border'></div>
                </NavItem>
                <NavItem id='myTab' role='tablist'>
                  <NavLink href='#' className={activeTab === '3' ? 'active' : ''} onClick={() => setActiveTab('3')}>
                    Chi tiết
                  </NavLink>
                  <div className='material-border'></div>
                </NavItem>
                <NavItem id='myTab' role='tablist'>
                  <NavLink href='#' className={activeTab === '4' ? 'active' : ''} onClick={() => setActiveTab('4')}>
                    Hình ảnh
                  </NavLink>
                  <div className='material-border'></div>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId='1'>
                  <H5>Mô tả sự kiện</H5>
                  <P attrPara={{ className: 'mb-0 m-t-20' }}>
                    {event.descriptionText || 'Mô tả chi tiết về sự kiện sẽ được cập nhật sớm. Sự kiện này được tổ chức với mục đích mang lại những trải nghiệm tuyệt vời cho người tham gia.'}
                  </P>
                  <P attrPara={{ className: 'mb-0 m-t-20' }}>
                    {event.descriptionText || 'Chúng tôi cam kết mang đến một sự kiện chất lượng cao với nội dung hấp dẫn và những hoạt động thú vị dành cho tất cả người tham gia.'}
                  </P>
                </TabPane>
                <TabPane tabId='2'>
                  <H5>Video sự kiện</H5>
                  <div className='mb-0 m-t-20'>
                    {event.eventVideos && event.eventVideos.length > 0 ? (
                      <div>
                        <p>Các video về sự kiện:</p>
                        <ul>
                          {event.eventVideos.map((video, index) => (
                            <li key={index}>
                              <a href={video} target="_blank" rel="noopener noreferrer">
                                Video {index + 1}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ) : (
                      <p>Chưa có video nào được cập nhật cho sự kiện này.</p>
                    )}
                  </div>
                </TabPane>
                <TabPane tabId='3'>
                  <H5>Chi tiết sự kiện</H5>
                  <div className='mb-0 m-t-20'>
                    <div className="event-details">
                      <p><strong>Tên sự kiện:</strong> {event.title}</p>
                      <p><strong>Ngày tổ chức:</strong> {event.date}</p>
                      <p><strong>Thời gian:</strong> {event.startTime && event.endTime ? `${event.startTime} - ${event.endTime}` : 'Chưa xác định'}</p>
                      <p><strong>Địa điểm:</strong> {event.location}</p>
                      <p><strong>Người tổ chức:</strong> {event.organizer}</p>
                      <p><strong>Loại sự kiện:</strong> {event.type === 'online' ? 'Trực tuyến' : 'Trực tiếp'}</p>
                      <p><strong>Số lượng tham gia tối đa:</strong> {event.maxAttendees || 'Không giới hạn'} người</p>
                      <p><strong>Trạng thái:</strong> {event.status === 'now' ? 'Đang diễn ra' : event.status === 'ended' ? 'Đã kết thúc' : 'Sắp diễn ra'}</p>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId='4'>
                  <H5>Hình ảnh sự kiện</H5>
                  <div className='mb-0 m-t-20'>
                    {event.eventImages && event.eventImages.length > 0 ? (
                      <div>
                        <p>Các hình ảnh về sự kiện:</p>
                        <div className="row">
                          {event.eventImages.map((image, index) => (
                            <div key={index} className="col-md-4 mb-3">
                              <img 
                                src={image} 
                                alt={`Event image ${index + 1}`}
                                className="img-fluid rounded"
                                style={{ 
                                  maxHeight: '200px', 
                                  minHeight: '150px',
                                  objectFit: 'cover',
                                  width: '100%',
                                  backgroundColor: '#f8f9fa'
                                }}
                                onError={(e) => {
                                  console.warn('Event image load error:', image);
                                  e.target.src = 'https://via.placeholder.com/300x200/6c757d/ffffff?text=No+Image';
                                }}
                                onLoad={() => {
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <p>Chưa có hình ảnh nào được cập nhật cho sự kiện này.</p>
                    )}
                  </div>
                </TabPane>
              </TabContent>
            </Col>
          </Row>
        </div>
      </Card>
    </Fragment>
  );
};

export default Tabset;
